import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-none",
  "use": "icon-none-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-none\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20ZM15.48,7.11,7.11,15.48a6,6,0,0,1,8.37-8.37Zm1.41,1.41a6,6,0,0,1-8.37,8.37Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol